<script>import Vue from 'vue';
import {mapState, mapActions} from 'vuex';
import {generateTempPath} from "../../services/DocumentService";
import {generateS3ImageDownloadPath} from "../../services/ConverterService";

export default Vue.extend({
    filters: {
        fileName(path) {
            return path.substring(path.indexOf('_') + 1, path.length);
        },
        tempPath(file) {
            return generateTempPath(file);
        },
        downloadPath(file) {
            return generateS3ImageDownloadPath(file);
        }
    },
    computed: {
        ...mapState({
            form: state => state.contract.contractManagement.form,
            contract: state => state.contract
        }),
        imagesList: {
            get() {
                return this.form[this.form.part][this.form.subPart][this.form.index].images;
            }
        },
        s3: {
            get() {
                return this.form[this.form.part][this.form.subPart][this.form.index].imagesS3;
            }
        }
    },
    methods: {
        ...mapActions({
            contractManagementFormSet: 'contract/contractManagementFormSet',
            contractManagementFormFileRemove: 'contract/contractManagementFormFileRemove',
            contractManagementFormFileDelete: 'contract/contractManagementFormFileDelete',
            contractManagementFormFileDownload: 'contract/contractManagementFormFileDownload',
            imageSizeViolation: 'contract/imageSizeViolation'
        }),
        add(obj) {
            this.contractManagementFormSet(obj);
            // Clear the input field value to ensure that the upload drag and drop works
            // when remove and then re-insert same file
            document.getElementById('contract-management-edit-images__input-file').value = "";
        },
        fileDelete(obj) {
            let confirm = window.confirm(this.$t('contractManagement.edit.form.upload.confirm'));
            if (confirm) {
                this.contractManagementFormFileDelete(obj);
            }
        },
        show(element) {
            element.style.opacity = 1;
        },
        hide(element) {
            element.style.opacity = 0;
        },
        checkForFileReader() {
            return window.FileReader !== null;
        }
    }
});
</script>
<template>
    <div class="contract-management-edit-images">
        <div v-if="checkForFileReader()" class="contract-management-edit-images__content">
            <div id="contract-management-edit-images__dropbox" class="contract-management-edit-images__dropbox">
                <input id="contract-management-edit-images__input-file"
                       :name="form.subPart"
                       type="file"
                       multiple
                       accept=".jpg,.jpeg,.bmp,.png"
                       class="contract-management-edit-images__input-file"
                       @change="add({part: form.part, subPart: form.subPart, images: $event.target.files})">
                <div v-if="imagesList.length === 0 && s3.length === 0" class="contract-management-edit-images__text" >
                    <p class="contract-management-edit-images__icon"><i class="fa fa-file-image-o"/></p>
                    <p class="contract-management-edit-images__initial">{{ $t('contractManagement.edit.form.images.initial') }}</p>
                    <p class="contract-management-edit-images__accepted">{{ $t('contractManagement.edit.form.images.accepted') }}</p>
                </div>
                <div class="contract-management-edit-images__images">
                    <span id="contract-management-edit-images__upload-images">
                        <span v-for="(file, index) in imagesList"
                              :key="'imageList_' + index"
                              class="contract-management-edit-images__thumb contract-management-edit-images__thumb-upload"
                        >
                            <img :src="file | tempPath" class="contract-management-edit-images__thumb-image">
                            <span class="contract-management-edit-images__thumb-buttons" @mouseenter="show($event.target)" @mouseleave="hide($event.target)">
                                <span class="contract-management-edit-images__thumb-button contract-management-edit-images__thumb-remove"
                                      @click="contractManagementFormFileRemove({part: form.part, subPart: form.subPart, index: index, type: 'images'})"/>
                            </span>
                        </span>
                    </span>
                    <span id="contract-management-edit-images__download-images">
                        <span v-for="(file, index) in s3"
                              :key="'s3imageList_' + index"
                              class="contract-management-edit-images__thumb"
                        >
                            <img :src="file | downloadPath" class="contract-management-edit-images__thumb-image">
                            <span class="contract-management-edit-images__thumb-buttons" @mouseenter="show($event.target)" @mouseleave="hide($event.target)">
                                <span class="contract-management-edit-images__thumb-button contract-management-edit-images__thumb-delete"
                                      @click="fileDelete({part: form.part, subPart: form.subPart, contractId: form.contractId, index: index, subIndex: form.index, type: 'image'})"/>
                                <a :href="file | downloadPath" target="_blank" class="contract-management-edit-images__thumb-button contract-management-edit-images__thumb-download"/>
                            </span>
                        </span>
                    </span>
                </div>
            </div>
        </div>
        <div v-if="!checkForFileReader()" class="contract-management-edit-images__error">
            <div class="contract-management-edit-images__error-icon"><i class="fa fa-frown-o"/></div>
            <div class="contract-management-edit-images__error-message">{{ $t('contractManagement.edit.form.images.unsupported') }}</div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractManagementEditImages/ContractManagementEditImages.vue